import { render, staticRenderFns } from "./deviceDetails.vue?vue&type=template&id=3211c080&scoped=true&"
import script from "./deviceDetails.vue?vue&type=script&lang=js&"
export * from "./deviceDetails.vue?vue&type=script&lang=js&"
import style0 from "./deviceDetails.vue?vue&type=style&index=0&id=3211c080&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3211c080",
  null
  
)

export default component.exports